<script setup>
import {computed} from 'vue';
import {settingsBreadcrumbsForKey} from './breadcrumbs';

const breadcrumbs = computed(() => settingsBreadcrumbsForKey('navigation:backOffice.sidebar.myCompany.settings.whitelabelApp'));
</script>

<template>
    <div class="w-full">
        <frosted-bar :breadcrumbs="breadcrumbs">
            <div class="flex items-center justify-between space-x-4">
                <h1>{{ _mft('navigation:backOffice.sidebar.myCompany.settings.whitelabelApp') }}</h1>
            </div>
        </frosted-bar>

        <company-whitelabel-app-offer />
    </div>
</template>
